export const defaultTitle = 'Clube de Vantagens';
export const publicationsDefaultTitle = `${defaultTitle} | Anúncios`;
export const companiesDefaultTitle = `${defaultTitle} | Anunciar`;
export const establishmentsDefaultTitle = `${defaultTitle} | Estabelecimentos`;
export const publicationBenefitsTitle = `${defaultTitle} | Benefícios`;

export const PAGE_TITLE = {
  defaultTitle,
  home: `${defaultTitle} | Home`,
  location: `${defaultTitle} | Informe seu endereço`,
  publications: {
    index: publicationsDefaultTitle,
    new: `${publicationsDefaultTitle} - Criar anúncio`,
    edit: `${publicationsDefaultTitle} - Editar anúncio`,
    reach: `${publicationsDefaultTitle} - Visualizar anúncio`,
    details: `${publicationsDefaultTitle} - Detalhes do anúncio`,
    establishments: `${publicationsDefaultTitle} - Selecionar estabelecimentos`,
    images: `${publicationsDefaultTitle} - Adicionar imagens`,
    search: `${publicationsDefaultTitle} - Busca`,
  },
  companies: {
    index: companiesDefaultTitle,
  },
  establishments: {
    index: establishmentsDefaultTitle,
    image: `${establishmentsDefaultTitle} - Adicionar imagem`,
    new: {
      index: `${establishmentsDefaultTitle} - Cadastrar estabelecimento`,
      hours: `${establishmentsDefaultTitle} - Adicionar horário`,
      contacts: `${establishmentsDefaultTitle} - Adicionar contato`,
    },
    edit: {
      index: `${establishmentsDefaultTitle} - Editar estabelecimento`,
      hours: `${establishmentsDefaultTitle} - Editar horário`,
      contacts: `${establishmentsDefaultTitle} - Editar contato`,
    },
  },
  categories: defaultTitle.concat(' | Moderação - Categorias'),
  rewards: defaultTitle.concat(' | Cartão-presente'),
};
